import {Box} from "@mui/material";
import BasicButton from "../../../../../common/BasicButton";
import useModalSetup from "../../../../../hooks/useModalSetup";
import commonStyles from "../../commonStyles";
import GorgiasViewsSetupModal from "./GorgiasViewsSetupModal";

export default function GorgiasViewsSetupEntry({trendsId, label, buttonLabel}) {
    const {handleOpenModal, handleCloseModal, openModal} = useModalSetup();

    return (
        <>
            <Box sx={commonStyles.labelMedium}>{label}</Box>
            <Box sx={styles.actionRow}>
                <Box sx={styles.actionButton}>
                    <BasicButton
                        label={buttonLabel}
                        action={handleOpenModal}
                        disabled={trendsId == null}
                    />
                </Box>
            </Box>

            <GorgiasViewsSetupModal
                title={label}
                trendsId={trendsId}
                open={openModal}
                handleClose={handleCloseModal}
            />
        </>
    );
}

const styles = {
    actionRow: {
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        mt: 0.5,
    },
    actionButton: {
        width: '160px',
    },
};
